var modules_7ff94741 = {"support-title":"Support_module_supportTitle__cb49cc9b","support-help":"Support_module_supportHelp__cb49cc9b"};
import "../../../assets/esm/components/Footer/src/Support~Cjpck9sK.css";

export { modules_7ff94741 as default };
//# sourceMappingURL=Support.module.less.js.map
